import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { NotesOutlined } from '@mui/icons-material';
import { useCostEditor } from '../../../../hooks/useCostEditor';

/**
 * CostNotesEditor - Multiline text input for cost-related notes
 * (e.g., vendor details, purchase order numbers, cost justifications).
 */
export const CostNotesEditor: React.FC = () => {
  const { costRecord, updateCostField } = useCostEditor();

  const handleChange = (value: string) => {
    updateCostField({ costNotes: value });
  };

  return (
    <TextField
      label="Cost Notes"
      value={costRecord?.costNotes || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      multiline
      minRows={2}
      maxRows={4}
      placeholder="Vendor details, PO numbers, cost justifications, etc."
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <NotesOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CostNotesEditor;
